import type { ArtikelRabattState } from "@/lib/artikelRabatt";
import type { ArtikelZuschlagState } from "@/lib/artikelZuschlag";
import {
  selectionFromRabattState,
  type RabattSelection,
} from "@/pages/artikel/ArtikelRabattSection";
import {
  selectionFromZuschlagState,
  type ZuschlagSelection,
} from "@/pages/artikel/ArtikelZuschlagSection";

export const INACTIVE_RABATT: RabattSelection = { modus: "inaktiv" };
export const INACTIVE_ZUSCHLAG: ZuschlagSelection = { modus: "inaktiv" };

export function isRabattActive(selection: RabattSelection): boolean {
  return selection.modus !== "inaktiv";
}

export function isZuschlagActive(selection: ZuschlagSelection): boolean {
  return selection.modus !== "inaktiv";
}

/**
 * Nur Rabatt oder Zuschlag darf aktiv sein.
 * Sind beide gespeichert, bleibt der Zuschlag (VK) aktiv.
 */
export function exclusivePriceSelectionsFromState(
  rabattState: ArtikelRabattState | null | undefined,
  zuschlagState: ArtikelZuschlagState | null | undefined,
): { rabatt: RabattSelection; zuschlag: ZuschlagSelection } {
  const rabatt = selectionFromRabattState(rabattState);
  const zuschlag = selectionFromZuschlagState(zuschlagState);
  if (isRabattActive(rabatt) && isZuschlagActive(zuschlag)) {
    return { rabatt: INACTIVE_RABATT, zuschlag };
  }
  return { rabatt, zuschlag };
}

export function activateRabatt(next: RabattSelection): {
  rabatt: RabattSelection;
  zuschlag: ZuschlagSelection;
} {
  return { rabatt: next, zuschlag: INACTIVE_ZUSCHLAG };
}

export function activateZuschlag(next: ZuschlagSelection): {
  rabatt: RabattSelection;
  zuschlag: ZuschlagSelection;
} {
  return { rabatt: INACTIVE_RABATT, zuschlag: next };
}
